import classNames from 'classnames';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { RichTextBoxColorPickerButton } from './RichTextBoxColorPickerButton';
import { RichTextBoxIndentButton } from './RichTextBoxIndentButton';
import { RichTextBoxToolbarBlockButton } from './RichTextBoxToolbarBlockButton';
import { RichTextBoxToolbarButton } from './RichTextBoxToolbarButton';
import { RichTextBoxToolbarFormatButton } from './RichTextBoxToolbarFormatButton';
import { RichTextBoxToolbarMenu } from './RichTextBoxToolbarMenu';

const InternalToolbar = React.forwardRef((
    props: React.HTMLAttributes<HTMLDivElement>,
    ref: React.ForwardedRef<HTMLDivElement>
) => {
    const { children, className, ...trimmedProps } = props;
    return (
        <RichTextBoxToolbarMenu ref={ref} attrs={{ className: classNames('richtextbox-toolbar', className), ...trimmedProps }}>
            {children}
        </RichTextBoxToolbarMenu>
    )
});
InternalToolbar.displayName = 'Toolbar';
InternalToolbar.propTypes = {
    className: PropTypes.string
}

export const RichTextBoxToolbar = Object.assign(observer(InternalToolbar), {
    Button: RichTextBoxToolbarButton,
    BlockButton: RichTextBoxToolbarBlockButton,
    FormatButton: RichTextBoxToolbarFormatButton,
    ColorPickerButton: RichTextBoxColorPickerButton,
    IndentButton: RichTextBoxIndentButton
});
